export const IconTiktok20: {
  name: 'icon_tiktok_20-1b0aa9832d24'
} = {
  name: 'icon_tiktok_20-1b0aa9832d24'
}
